import { useState, useEffect } from "react";

export const useHttp = (url, dependencies) => {
  const [fetchedData, setFetchedData] = useState(null);

  useEffect(() => {
    console.log("Running http fetch");
    fetch(url)
      .then((response) => {
        if (response.ok) {
          console.log("Data fetched from web");
          console.log(response.url);
          return response.json();
        } else {
          alert("HTTP-Error: " + response.status);
        }
      })
      .then((data) => {
        setFetchedData(data);
      })
      .catch((err) => {
        console.log("Failed to fetch data from web");
      });
  }, [url]);

  return fetchedData;
};

export const timeoutGet = (url, params) => {
  let query = Object.keys(params)
    .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
    .join("&");

  let urlQuery = url + "?" + query;
  let options = {
    method: "GET",
    headers: {
      "x-api-key": "POpk77F6Ub7A82CM9oeIn6CQtC2oDDVUcZZRn16g",
    },
  };

  // https://davidwalsh.name/fetch-timeout
  const FETCH_TIMEOUT = 5000;
  let didTimeOut = false;

  const result = new Promise(function (resolve, reject) {
    const timeout = setTimeout(function () {
      didTimeOut = true;
      reject(new Error("Request timed out"));
    }, FETCH_TIMEOUT);

    console.log("fetch ", urlQuery, options);
    fetch(urlQuery, options)
      .then(function (response) {
        // Clear the timeout as cleanup
        clearTimeout(timeout);
        if (!didTimeOut) {
          console.log("fetch good! ", response);
          if (response.ok) {
            console.log("Data fetched from web");
            console.log(response.url);
            resolve(response.json());
          } else {
            alert("HTTP-Error: " + response.status);
            resolve({});
          }
        }
      })
      .catch(function (err) {
        console.log("fetch failed! ", err);
        // Rejection already happened with setTimeout
        if (didTimeOut) return;
        // Reject with error
        reject(err);
      });
  })

    .then(function (data) {
      // Request success and no timeout
      console.log("good promise, no timeout! ");
      return data;
    })
    .catch(function (err) {
      // Error: response error, request timeout or runtime error
      console.log("promise error! ", err);
    });

  return result;
};

export const timeoutPost = (url, data) => {
  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-api-key": "POpk77F6Ub7A82CM9oeIn6CQtC2oDDVUcZZRn16g",
    },
    body: JSON.stringify(data),
  };

  // https://davidwalsh.name/fetch-timeout
  const FETCH_TIMEOUT = 5000;
  let didTimeOut = false;

  const result = new Promise(function (resolve, reject) {
    const timeout = setTimeout(function () {
      didTimeOut = true;
      reject(new Error("Request timed out"));
    }, FETCH_TIMEOUT);

    console.log("fetch ", url, options);
    fetch(url, options)
      .then(function (response) {
        // Clear the timeout as cleanup
        clearTimeout(timeout);
        if (!didTimeOut) {
          console.log("fetch good! ", response);
          if (response.ok) {
            console.log("Data fetched from web");
            console.log(response.url);
            resolve(response.json());
          } else {
            alert("HTTP-Error: " + response.status);
            resolve({});
          }
        }
      })
      .catch(function (err) {
        console.log("fetch failed! ", err);
        // Rejection already happened with setTimeout
        if (didTimeOut) return;
        // Reject with error
        reject(err);
      });
  })

    .then(function (data) {
      // Request success and no timeout
      console.log("good promise, no timeout! ");
      return data;
    })
    .catch(function (err) {
      // Error: response error, request timeout or runtime error
      console.log("promise error! ", err);
    });

  return result;
};
